import { GetServerSideProps } from "next";

import NetworkSearchPage from "~/templates/network/NetworkSearchPage";

export const getServerSideProps: GetServerSideProps = async () => {
  const isProductionEnv = process.env.ENVIRONMENT === "production";
  return {
    props: {
      isProductionEnv,
    },
  };
};

export default NetworkSearchPage;

export interface Country {
  id: string;
  name: string;
}
